import { extendTheme } from '@chakra-ui/react';

const theme = {
    baseStyle: {
        fontWeight: 'semibold',
        border: '10px',
        menuButton: {
            _focus: {
                boxShadow: 'none'
            }
        }
    }
}

export default theme